<!--
  Loading Dialog
  진행중인 상태를 출력하는 알림 팝업

  @since 2018-03-16
  @author kdydesign.kim
-->

<template>
  <q-dialog v-model="isShow"
            ref="loadingDialog"
            stack-buttons
            prevent-close
            class="bs bs-q-dialog bs-q-dialog-ongoing">
    <div slot="body">
      <div class="dialog-body-group">
        <div class="contents-row">
          <p class="dialog-body-ico">
            <q-spinner color="primary"
                       size="50"
                       class="bs bs-q-spinner bs-q-spinner-default"></q-spinner>
          </p>
          <p>{{message}}</p>
        </div>
      </div>
    </div>

    <template v-if="stopButton"
              slot="buttons"
              slot-scope="props">
      <q-toolbar slot="footer">
        <div class="contents-row">
          <div class="footer-option-group">
            <div class="row bs-q-btn-dialog-group">
              <q-btn label="stop"
                     :auth-force="true"
                     outline="outline"
                     @click="onStop()"
                     class="bs bs-q-btn-sm bs-q-btn-icon bs-q-btn-popup-line"></q-btn>
            </div>
          </div>
        </div>
      </q-toolbar>
    </template>
  </q-dialog>
</template>

<script>
  // plugin component
  import {LoadingPopUp} from '~/plugins/components'

  export default {
    name: 'LoadingDialog',
    props: {
      stopButton: {
        type: Boolean,
        default: false
      },
      message: {
        type: String,
        default: 'Loading...'
      },
      stopHide: {
        type: Boolean,
        default: true
      },
      // TAMS
      global: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isShow: false
      }
    },
    beforeMount () {
      // TAMS
      if (this.global) {
        LoadingPopUp.event.$on('show', (opts) => {
          this.show(opts)
        })

        LoadingPopUp.event.$on('hide', (message) => {
          this.hide(message)
        })
      }
    },
    // beforeDestroy () {
    //   LoadingPopUp.event.$off('show')
    //   LoadingPopUp.event.$off('hide')
    // },
    methods: {
      onStop () {
        this.$emit('onStop')
        if (this.stopHide) {
          this.hide()
        }
      },
      show (props) {
        if (this.isShow) { return }
        if (props) {
          if (_.has(props, 'stopButton')) {
            this.stopButton = props.stopButton
          }

          if (_.has(props, 'message')) {
            this.message = props.message
          }
        }

        this.$nextTick(() => {
          this.$refs.loadingDialog.show()
        })
      },
      hide (message) {
        if (!_.has(this.$refs, ['loadingDialog', 'hide'])) {
          return
        }

        this.$nextTick(() => {
          this.$refs.loadingDialog.hide()

          if (message) {
            this.$alertPopUp.show(message)
          }
        })
      }
    }
  }
</script>
